type AccessDeniedPageProps = {
  reason: "portal" | "page" | "checkFailed";
  detail?: string;
};

export default function AccessDeniedPage({ reason, detail }: AccessDeniedPageProps) {
  const message = reason === "portal"
    ? "Je hebt geen toegang tot de interne portal. Neem contact op met een portalbeheerder om toegang aan te vragen."
    : reason === "checkFailed"
      ? "Je toegang kon niet worden gecontroleerd. Probeer de pagina opnieuw te laden. Blijft dit gebeuren, neem dan contact op met een portalbeheerder."
      : "Je hebt geen toegang tot deze pagina. Neem contact op met een portalbeheerder.";

  return (
    <section className="it-page it-surface p-6 text-slate-700 dark:text-slate-300">
      <h1 className="text-lg font-bold text-slate-900 dark:text-white">{reason === "checkFailed" ? "Toegangscontrole mislukt" : "Toegang geweigerd"}</h1>
      <p className="mt-2">{message}</p>
      {reason === "checkFailed" && detail && <p className="mt-2 text-sm">Technische details: {detail}</p>}
    </section>
  );
}
